<template>
  <div class="purchasePage">
    <!-- 导航 -->
    <switchCard myTitle="订单详情" ></switchCard>
    <!-- 地址 -->
    <div class="orderDetailAdress" v-if="myorderData&&myorderData.shippingEntity">
        <div class="adreeIcon">
            <img src="../../../assets/adress.png" alt="" class="imgAdress">
        </div>
        <div class="adressContent">
            <div class="namePhone">
                <p>{{ myorderData.shippingEntity.receiverName }}</p>
                <p class="phoneStyle">{{ myorderData.shippingEntity.receiverMobile }}</p>
            </div>
            <div class="adressOther">
                {{ myorderData.shippingEntity.receiverPrivince }} {{ myorderData.shippingEntity.receiverCity }} {{ myorderData.shippingEntity.receiverDistrict }}
                {{ myorderData.shippingEntity.receiverAddress }}
            </div>
        </div>
        <!-- <div style="width: 10%;text-align: center;"><p class="towardsTheRight"></p></div> -->
    </div>
    <div style="width: 100%;height: 15px;background-color: #F1F1F1"></div>
    <!-- 商品信息 -->
    <div class="allOrder" v-if="myorderData">
        <div class="orderNumber">订单号：{{myorderData.orderNo}}</div>
        <van-card
            v-for="(item,indexItem) in myorderData.orderItemEntityList" :key="indexItem"
            :num="item.quantity"
            :desc="item.productBlandName?'品牌：'+item.productBlandName:''"
            :title="item.productName"
            :thumb="item.productImage"
        >
            <template #price>
            <span>{{shopOrintegral=="shop"?'￥'+item.totalPrice:item.totalIntegral+' 积分'}}</span>
            </template>
        </van-card>
        <div class="oprationOrder">
            <span>{{myorderData.status|changeBlock}}</span>
            <!-- <van-button type="warning" size="small">物流信息</van-button> -->
            <!-- <van-button type="warning" size="small" @click="orderXiangQing(myorderData)">订单详情</van-button> -->
        </div>
    </div>
    <!-- <div style="width: 100%;height: 15px;background-color: #F1F1F1"></div> -->
    <!-- <div class="">
        <div v-if="!onLogisticData" class="noOnLogistic">
            暂无物流信息！
        </div>
    </div> -->
    <!-- 生成二维码 -->
    <div style="width: 100%;height: 15px;background-color: #F1F1F1" v-show="myorderData&&myorderData.status!=10&&myorderData.status!=60"></div>
    <div class="qrcodeContentBox" v-show="myorderData&&myorderData.status!=10&&myorderData.status!=60">
        <p class="qrcodeTitle">提货二维码</p>
        <div id="qrcodeContent"></div>
    </div>
  </div>
</template>

<script>
import QRCode  from "qrcodejs2" //生成二维码
import AES from "@/utils/AES.js"; //AES加密
import switchCard from "./allNav.vue";
export default {
    components:{
        switchCard
    },
    data(){
        return{
            myorderData:null, //我的订单信息
            onLogisticData:null,
        }
    },
    filters:{
        changeBlock(str){
            if(str=="0"){
                return "交易已取消"
            }else if(str=="10"){
                return "交易未付款"
            }else if(str=="20"){
                return "交易已付款"
            }else if(str=="40"){
                return "交易已发货"
            }else if(str=="50"){
                return "交易成功"
            }else if(str=="60"){
                return "交易关闭"
            }
        }
    },
    created(){
        this.orderLinkData(); //我的信息
    },
    methods:{
        // 订单详情
        orderLinkData(){
            var data={
                typeId:this.wenOrRong,
                userId:window.localStorage.civilizationId,
                orderNo:this.$route.query.orderId
            }
            this.$http.post(this.javalinkTwo +"mmall/order/selectUserOrder",data,{
                params:{
                    rows:10,
                    sortBy:'create_time',
                    desc:true,
                    page:1
                }
            })
            .then(res => {
                // console.log(res.data);
                if(res.data.success){
                    if(res.data.data.items.length>0){
                        this.myorderData = res.data.data.items[0];
                        // userId=用户id&dateTime=当前时间戳&orderNo=订单号&typeId=1；
                        // 对上述字符串进行AES加密
                        // 域名+api/mmall/order/shipping?count=加密后的字符串
                        // 上述链接转成二维码
                        var scopedStr = 'userId='+window.localStorage.civilizationId+
                                        '&dateTime='+new Date().getTime()+
                                        '&orderNo='+this.$route.query.orderId+
                                        '&typeId=1'
                        let user = AES.encrypt(scopedStr); //AES加密
                        var allLink=this.javalinkTwo+'mmall/order/shipping?count='+ user ;   
                        allLink=allLink.replace(/\+/g,"@");
                        this.$nextTick(()=>{ //生成二维码
                            this.qrcode(allLink); //生成二维码
                        })           
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 物流信息
        // onLogistics(){
        //     if(!this.myorderData.fastMailSign||!this.myorderData.fastMailName) {
        //         return false;
        //     }
        //     var data={
        //         fastMailSign: this.myorderData.fastMailSign,
        //         fastMailNumber: this.myorderData.isHaveFastMail
        //     }
        //     this.$http.post(this.javalinkTwo +"mmall/fastMail/getFastMailInfoHTTP",data,{})
        //     .then(res => {
        //         // console.log(res.data);
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     });
        // },
        // 生成二维码
        qrcode (str) {
            // let that = this;
            // console.log(QRCode);
            var qrcodeCon = QRCode;
            // let qrcode = 
            new QRCode('qrcodeContent', {
                width: 200,
                height: 200,        // 高度
                text: str,   // 二维码内容
                correctLevel:qrcodeCon.CorrectLevel.Q  
                // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                // background: '#f0f',   // 背景色
                // foreground: '#eee'    // 前景色
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .purchasePage .van-card{
        background: #fff;
    }
    .purchasePage{
        width: 100%;
        height: 100%;
    }
    // 地址
    .noAddress {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
    }
    .towardsTheRight {
        display: block;
        width: 12px;
        height: 12px;
        border-top: 2px solid #ccc;
        border-right: 2px solid #ccc;
        transform: rotate(45deg);
    }
    .orderDetailAdress {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
        font-size: 14px;
        padding: 10px 0px;
    }
    .adreeIcon {
        width: 20%;
    }
    .imgAdress {
        width: 100%;
        height: auto;
        object-fit: contain;
    }
    .adressContent {
        width: 80%;
        display: flex;
        flex-direction: column;
    }
    .namePhone {
        font-size: 14px;
        margin-bottom: 10px;
        display: flex;
    }
    .phoneStyle {
        color: #999;
        margin-left: 20px;
    }
    // 订单信息
    .allOrder{
        width: 100%;
        margin-bottom: 15px;
    }
    .orderNumber {
        padding: 8px 16px;
        background: #fff;
        box-sizing: border-box;
        padding-top: 20px;
    }
    .oprationOrder {
      width: 100%;
      background: #fff;
      padding: 8px 16px;
      display: flex;
      justify-content: flex-end;
      box-sizing: border-box;
      border-top: 1px solid #eee;
      align-items: center;
    }
    .noOnLogistic{
        width: 100%;
        text-align: center;
        margin-top: 15px;
    }

    // 二维码
    .qrcodeContentBox{
        width: 100%;
        height: 300px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .qrcodeTitle{
        margin-bottom: 20px;
        font-size: 18px;
    }
</style>